import { useState, useEffect } from 'react';
import { toast } from 'sonner';

export const useApi = (apiFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await apiFunction();
        if (isMounted) {
          setData(result);
        }
      } catch (err) {
        if (isMounted) {
          setError(err);
          console.error('API Error:', err);
          toast.error('Error cargando datos: ' + (err.response?.data?.detail || err.message));
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, dependencies);

  const refetch = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiFunction();
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      console.error('API Error:', err);
      toast.error('Error cargando datos: ' + (err.response?.data?.detail || err.message));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refetch };
};

export const useSearch = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = async (searchFunction) => {
    try {
      setLoading(true);
      setError(null);
      const result = await searchFunction();
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      console.error('Search Error:', err);
      toast.error('Error en búsqueda: ' + (err.response?.data?.detail || err.message));
      setData([]);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, search };
};